export const BONUS_KINDS = {
  welcome: 'welcome',
  falcon: 'falcon',
};
